
        <!-- header area start -->
        <div class="header2">
            <div class="">
                <div class="topHeader">
                    <div class="logo">
                        <img src="../../../../assets/img/autotrader.png" alt="">

                        <i class="fa-solid fa-bars"></i>
                    </div>
                    <div class="search">
                        <input type="text" class="form-control">
                        <button class="btn" type="button"><i class="fa-solid fa-magnifying-glass"></i> Search</button>
                    </div>

                    <div class="login">
                        <ul class="log">
                            <li>
                                <div class="dropdown">
                                    <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                      English
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                      <li><a class="dropdown-item">Arabic</a></li>
                                      <li><a class="dropdown-item">French</a></li>
                                      <li><a class="dropdown-item">German</a></li>
                                    </ul>
                                  </div>
                            </li>

                            <li>
                                <a>
                                    <img src=".//img/Vector.png" alt="">
                                    Login
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="bottomHeader">
                    <ul>
                        <li><a><i class="fa-solid fa-house"></i> Home</a></li>
                        <li><a>Used Cars</a></li>
                        <li><a>Compare</a></li>
                        <li><a>Deals</a></li>
                    </ul>

                    <a>
                        <button class="btn" type="button">Sell Your Car</button>
                    </a>
                    
                </div>
            </div>
        </div>
        <!-- header area end -->

        <!-- ad banner -->
        <div class="adBanner">
            <div class="container">
                <img src="./img/banner-1.png" class="img-fluid" alt="">
            </div>
        </div>


        <!-- post details section start -->

        <div class="postDetail">
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                        <div class="leftArea">
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                 <li [routerLink]="['/'+ handle]" style="cursor: pointer;margin-right: 10px;">
                                    <i class="fa-solid fa-turn-down-left fa-beat-fade fa-lg tooltip" style="color: #4e1f51;">
                                        <span class="tooltiptext">Go Back</span>
                                    </i>
                                   
                                </li> 
                                  <li class="breadcrumb-item"><a>Cars & Bikes</a></li>
                                  <li class="breadcrumb-item active" aria-current="page">Ad Details</li>
                                </ol>
                            </nav>

                            <h2 class="title">{{details?.ListingHeader}}</h2>
                            <ul>
                                <li class="date">{{details?.GoliveTimeStamp | date}}</li>
                                <li>Category: <a>{{details?.CarType}}</a> </li>
                                <li>Views: {{details?.ViewCount}}</li>
                                <li><a>Edit</a></li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-md-4 my-auto">
                        <div class="rightArea">
                            <h5 class="priceTag">
                              {{dealerData?.PrimaryCurrencyText}}15,000<span>Fixed</span> 
                                <img src="./img/tag.png" alt="">
                            </h5>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-8">
                        <div class="leftArea">
                            <mdb-carousel class="carousel slide carousel-fade">
                                <mdb-carousel-item *ngFor="let item of media">
                                    <img *ngIf="item.MediaType == 'I' && item.MediaURL" [src]="item.MediaURL"
                                        class="d-block w-100 rounded" alt="image" (error)="item.MediaURL = null" />
                                    <video *ngIf="item.MediaType != 'I' && item.MediaURL" class="d-block w-100 rounded" controls
                                        (error)="item.MediaURL = null">
                                        >
                                        <source [src]="item.MediaURL" type="video/mp4" (error)="item.MediaURL = null" />
                                        Your browser does not support the video tag.
                                    </video>
                                    <h4 *ngIf="!item.MediaURL">
                                        <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/not-found.png" />
                                    </h4>
                                </mdb-carousel-item>
                            </mdb-carousel>
                           

                            <div class="detailsInfo">
                                <ul>
                                    <li>
                                        <i class="fa-light fa-gas-pump"></i>
                                        <p>{{details?.FuelType}}</p>
                                    </li>
                                    <li>
                                        <i class="fa-light fa-road"></i>
                                        <p>35,000 km</p>
                                    </li>
                                    <li>
                                        <i class="fa-light fa-closed-captioning"></i>
                                        <p>1800 cc</p>
                                    </li>
                                    <li>
                                        <i class="fa-light fa-calendar-days"></i>
                                        <p>{{details?.MakeYear}}</p>
                                    </li>
                                    <li>
                                        <i class="fa-light fa-gear"></i>
                                        <p>{{details?.Transmission}}</p>
                                    </li>
                                    <li>
                                        <i class="fa-light fa-car"></i>
                                        <p>{{details?.CarType}}</p>
                                    </li>
                                    <li>
                                        <i class="fa-light fa-paint-roller"></i>
                                        <p>{{details?.Color}}</p>
                                    </li>
                                </ul>
                            </div>

                            <div class="detailText">
                                <h5>Description</h5>
                                <p>{{details?.Description}}</p>

                                <div class="row mb-5 mt-4">
                                    <div class="col-md-4">
                                        <p><b>Condition</b> : Used</p>
                                        <p><b>Product Type</b> : {{details?.CarType}}</p>
                                    </div>

                                    <div class="col-md-4">
                                        <p><b>Brand </b> : {{details?.BrandName}}</p>
                                        <p><b>Date </b> : {{details?.GoliveTimeStamp | date}}</p>
                                    </div>

                                    <div class="col-md-4">
                                        <p><b>Model  </b> :  Lumia 625</p>
                                        <p><b>Price  </b> : Rs. 22,000</p>
                                    </div>
                                </div>

                                <h5>Specifications</h5>
                                <p>{{details?.Specifications}}</p>
                               
                                <img src="./img/car-img1.png" class="carImage img-fluid" alt="">

                                <h5 class="mb-4">Car Features</h5>

                                <div class="row">
                                    <div class="col-md-4">
                                        <ul>
                                            <li><i class="fa-light fa-heart"></i>  AM/FM Radio</li>
                                            <li><i class="fa-light fa-lock"></i> Power Locks</li>
                                            <li><i class="fa-light fa-window-frame-open"></i> Power Windows</li>
                                            <li><i class="fa-light fa-steering-wheel"></i> Cruise Control</li>
                                        </ul>
                                    </div>
                                    <div class="col-md-4">
                                        <ul>
                                            <li><i class="fa-light fa-heart"></i>  AM/FM Radio</li>
                                            <li><i class="fa-light fa-lock"></i> Power Locks</li>
                                            <li><i class="fa-light fa-window-frame-open"></i> Power Windows</li>
                                            <li><i class="fa-light fa-steering-wheel"></i> Cruise Control</li>
                                        </ul>
                                    </div>
                                    <div class="col-md-4">
                                        <ul>
                                            <li><i class="fa-light fa-heart"></i>  AM/FM Radio</li>
                                            <li><i class="fa-light fa-lock"></i> Power Locks</li>
                                            <li><i class="fa-light fa-window-frame-open"></i> Power Windows</li>
                                            <li><i class="fa-light fa-steering-wheel"></i> Cruise Control</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="detailVideo">
                                <iframe width="100%" height="350" src="https://www.youtube.com/embed/yh0ZGHiizSA" title="Car Intro Video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>

                            <div class="createAleart">
                                <h5>Create Alert</h5>
                                <p>Receive emails for the latest ads matching your search criteria</p>
                                <div class="row">
                                    <div class="col-md-5">
                                        <input type="text" class="form-control" placeholder="enter email here">
                                    </div>
                                    <div class="col-md-4">
                                        <select class="form-select" aria-label="Default select example">
                                            <option selected="">Daily</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <a>
                                            <button class="btn" type="button">SUBMIT</button>
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="rightArea">
                            <a>
                                <button class="btn" type="button">
                                    <img src="./img/icon1.png" alt="">
                                    Contact Seller Via Email
                                </button>
                            </a>

                            <a>
                                <button class="btn" type="button">
                                    <img src="./img/icon2.png" alt="">
                                    0320XXXXXXXX
                                </button>
                            </a>

                            <div class="userProfile">
                                <img src="./img/3.jpg" alt="">
                                <div class="rightDetail">
                                    <h5>Sonu Monu</h5>
                                    <p>Published on: 10 Dec 2017</p>
                                    <a>More Ads</a>
                                </div>
                            </div>
                        </div>

                        <div class="recentAdd">
                            <h5>Recent Ads</h5>

                            <div class="row">
                                <div class="col-4">
                                    <img src="./img/thumb-1.jpg" class="img-fluid" alt="">
                                </div>
                                <div class="col-8">
                                    <h6>
                                        <a>
                                            2010 Audi A5 Auto Premium quattro MY10
                                        </a>
                                    </h6>
                                    <p>NEW YORK, BROOKLYN</p>
                                    <div class="price">
                                        $ 17,000
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-4">
                                    <img src="./img/thumb-1.jpg" class="img-fluid" alt="">
                                </div>
                                <div class="col-8">
                                    <h6>
                                        <a>
                                            2010 Audi A5 Auto Premium quattro MY10
                                        </a>
                                    </h6>
                                    <p>NEW YORK, BROOKLYN</p>
                                    <div class="price">
                                        $ 17,000
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-4">
                                    <img src="./img/thumb-1.jpg" class="img-fluid" alt="">
                                </div>
                                <div class="col-8">
                                    <h6>
                                        <a>
                                            2010 Audi A5 Auto Premium quattro MY10
                                        </a>
                                    </h6>
                                    <p>NEW YORK, BROOKLYN</p>
                                    <div class="price">
                                        $ 17,000
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="recentAdd">
                            <h5>Financing Calculator</h5>
                            <div class="row">
                                <div class="col-12 p-0">
                                    <label for="">Vehicle price</label>
                                    <select class="form-select" aria-label="Default select example">
                                        <option selected>$ 30,000</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                      </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 p-0">
                                    <label for="">Interest rate</label>
                                    <select class="form-select" aria-label="Default select example">
                                        <option selected>30%</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                      </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 p-0">
                                    <label for="">Down Payment</label>
                                    <input type="text" class="form-control" placeholder="$316,000">
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 p-0">
                                    <a>
                                        <button class="btn btn1" type="button">Calculate</button>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="recentAdd">
                            <h5>Safety tips for deal</h5>
                            <div class="row">
                                <div class="col-12 p-0">
                                    <ul>
                                        <li>Use a safe location to meet seller</li>
                                        <li>Avoid cash transactions</li>
                                        <li>Beware of unrealistic offers</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>

        <footer>
            <div class="container">
                <div class="row">
                    <div class="col-md-5">
                        <img src="./img/autotrader.png" class="logo" alt="">
                        <p class="mb-4">CarSpot Automotive Car Classified WordPress Theme is flexible and powerful Car Classified wordpress Theme for your all automotive & car listing business needs.</p>
                        <ul class="social">
                            <li><a><i class="fa-brands fa-facebook-f"></i> </a></li>
                            <li><a><i class="fa-brands fa-twitter"></i> </a></li>
                            <li><a><i class="fa-brands fa-linkedin-in"></i> </a></li>
                            <li><a><i class="fa-brands fa-google-plus-g"></i></a></li>
                            <li><a><i class="fa-brands fa-youtube"></i> </a></li>
                        </ul>
                    </div>
                    <div class="col-md-4">
                        <h5>Quick Links</h5>

                        <div class="d-flex">
                            <ul>
                                <li><a>Home</a></li>
                                <li><a>About Us</a></li>
                                <li><a>Comparison</a></li>
                                <li><a>Expert Reviews</a></li>
                            </ul>
    
                            <ul>
                                <li><a>Elements</a></li>
                                <li><a>Checkout</a></li>
                                <li><a>Packages</a></li>
                                <li><a>Contact Us</a></li>
                            </ul>
                        </div>
                     
                    </div>
                    <div class="col-md-3">
                        <h5>Get Our Apps</h5>
                        <a  class="google">
                            <img src="./img/google.png" alt="">
                        </a>
                        <a class="apple">
                            <img src="./img/apple.png" alt="">
                        </a>
                    </div>

                    <div class="col-12 text-center">
                        <p class="copyright">© Copyright 2022  </p>
                    </div>
                </div>
            </div>
        </footer>
    